import React from 'react';
import SquadDetailsPageInner from '../domains/squads/components/SquadDetailsPage';

const AdminSquadDetailsPage: React.FC = () => {
  return <SquadDetailsPageInner mode="admin" />;
};

export default AdminSquadDetailsPage;

